export default __webpack_public_path__ + "static/media/data-analysis.89d37acb.png";